import { Injectable } from '@angular/core';

export const TYPE_MAP = new Map();
// tslint:disable-next-line:no-empty-interface
export interface TypeManager {
}

@Injectable({
  providedIn: 'root'
})
export class TypeManagerService {

  constructor() { }

  public typeMap(type: string) {
    return (TYPE_MAP.has(type)) ? TYPE_MAP.get(type) : undefined;
  }

  addType(key: string, factory) {
    TYPE_MAP.set(key, factory);
  }

}
